/**
 * Created by Daniela on 23/01/2017.
 */
import { Injectable } from '@angular/core';

import { AuthService } from "../../../shared/services/auth.service";
import { editRoute, newRoute } from "../../../shared/services/data.service";
import { abastecimentosRoute } from "../../shared/data.service";
import { tipoAjustesRoute } from "./data.service";

@Injectable()
export class TipoAjusteNavigationService {

    constructor(
        private _authService: AuthService
    ) { }

    goToList() {
        let router: string = abastecimentosRoute + '/' + tipoAjustesRoute;
        this._authService.navigateTo(router);
    }

    goToNew() {
        let router: string = abastecimentosRoute + '/' + tipoAjustesRoute + '/' + newRoute;
        this._authService.navigateTo(router);
    }

    goToEdit(objectId: number) {
        let router: string = abastecimentosRoute + '/' + tipoAjustesRoute + '/' + editRoute;
        this._authService.navigateTo(router, objectId);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/tipo-ajustes/shared/tipo-ajuste-navigation.service.ts
 **/